import {Component, Input, OnInit} from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import {CognitoUser} from 'amazon-cognito-identity-js';

import { Subject } from 'rxjs';
import {AuthValidators} from '../../../../validators/auth.validators';
import {AuthService} from '../../../../service/auth.service';

@Component({
  selector: 'app-sign-in-change-password',
  templateUrl: './sign-in-change-password.component.html',
  styleUrls: ['./sign-in-change-password.component.scss']
})
export class SignInChangePasswordComponent implements OnInit {
  form: FormGroup;
  loading: boolean;

  hasError: string;

  password$ = new Subject<string>();

  @Input() user: CognitoUser;

  constructor(private authService: AuthService) {}

  ngOnInit() {
    this.form = new FormGroup({
      newPassword: new FormControl(null, [Validators.required, AuthValidators.checkPassword]),
      confirmNewPassword: new FormControl(null, [Validators.required, this.checkConfirmPassword.bind(this)])
    });
  }

  get newPassword(): AbstractControl {
    return this.form.get('newPassword');
  }

  get confirmNewPassword(): AbstractControl {
    return this.form.get('confirmNewPassword');
  }

  sendPasswordToRules(value: string): void {
    this.password$.next(value);
  }

  checkConfirmPassword(confirmPassword: FormControl | AbstractControl) {
    if (!this.form) {
      return null;
    }
    const password: AbstractControl = this.form.controls.newPassword;
    return confirmPassword.value === password.value ? null : { different: true };
  }

  cancel() {
    this.authService.newPasswordRequired.emit(null);
  }

  changePassword() {
    this.authService.changePassword(this.user, this.newPassword.value)
      .catch(err => {
        console.error(err);
      })
      .finally(() => this.loading = false);
  }
}
